<div class="col-md-12">
	<div class="row text-left">
		<button class="x-create btn btn-primary">{{{JspPublicCodes_JSP_ITEM_ALERTS_CREATE_ALERT}}}</button>
	</div>
	<br>
</div>
